<template>
    <div class="course-manage">
        <div class="add-btn-left">
            <el-button type="primary" @click="addClassify()">
                <i class="el-icon-plus"></i>添加分类
            </el-button>
        </div>
        <el-table :data="questionsTable"  style="width: 100%; flex: 1" height="1%" size="medium"
                  :tree-props="{children: 'children', hasChildren: 'hasChildren'}" :row-key="getRowKey" :expand-row-keys="expands"
                  :header-cell-style="{fontWeight: 'normal', color: '#666', background: '#eee',fontSize: '16px',height:'60px'}"
                  class="customTable"  :cell-style="{fontSize: '12px',color: '#333',height: '70px'}">
            <el-table-column prop="name" label="名称"></el-table-column>
            <el-table-column label="操作" align="center" width="240px">
                <template slot-scope="scope">
                    <div class="link-list">
                        <el-link type="success" :underline="false" v-if="scope.row.level===1" @click="addClassify(scope.row)">添加子分类</el-link>
                        <el-link type="success" :underline="false"  v-else-if="scope.row.level===2" @click="addClassify(scope.row)">添加三级分类</el-link>
                        <el-link type="success" :underline="false"  v-else style="visibility: hidden">添加三级分类</el-link>
                        <el-link type="success" :underline="false" @click="editClassify(scope.row)">编辑</el-link>
                        <el-link type="primary" :underline="false" @click="deleteClassifyRow(scope.row.id)">删除</el-link>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
                class="pages-center"
                :current-page="coursePages.currentPageNum"
                :page-size="coursePages.eachPageNum"
                layout="prev, pager, next, jumper"
                :total="coursePages.total"
                @current-change="courseCurrentChange">
        </el-pagination>
        <el-dialog :title="classifyTitleType" :visible.sync="dialogAddClassify"  custom-class="green-dialog centerDialog" width="500px" @close="resetForm()" :close-on-click-modal="false">
            <el-form :model="addClassifyForm" ref="addClassifyForm" :rules="resources" label-position="top">
                <el-form-item label="分类名称" :label-width="formLabelWidth" prop="name">
                    <el-input v-model="addClassifyForm.name" autocomplete="off"></el-input>
                </el-form-item>
            </el-form>
            <div class="dialog-footer">
                <el-button size="medium" @click="dialogAddClassify = false">取 消</el-button>
                <el-button size="medium" type="primary" plain @click="addToForm('addClassifyForm')">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import {add, catePage, del} from '@/utils/apis'
    export default {
        name: "Questions",
        data(){
            return{
                questionsTable:[],
                expands: [],
                dialogAddClassify:false,
                classifyTitleType:'',
                addClassifyForm:{
                    name: '',
                    id: '',
                },
                resources: {
                    name: [
                        { required: true, message: '请输入分类名称', trigger: 'blur' },
                        { min: 1, max: 20, message: '长度在 1 到 20 个字符', trigger: 'blur' }
                    ],
                },
                formLabelWidth:'80px',
                //分页
                coursePages: {
                    currentPageNum: 1,
                    eachPageNum: 10,
                    total: 0
                },
                currentLevel: null,
            }
        },
        mounted() {
            this.getQuestionsList()
            this.expands = this.getRowKeys(this.questionsTable);
        },
        methods:{
            // // 添加分类
            // addLevelOne(){
            //     this.dialogAddClassify =!this.dialogAddClassify
            //     this.classifyTitleType='添加分类'
            // },
            //处理等级函数
            grading(data){
                data['level']=1;
                if('children' in data){
                    for (let i in data.children){
                        data.children[i]['level']=2;
                    }
                    if('children' in data.children){
                        for (let i in data.children.children){
                            data.children.children[i]['level']=3;
                        }
                    }
                }
                return data
            },
            getRowKey(row) {
                return row.id;
            },
            getRowKeys(data) {
                let arr = [];
                if (data.length === 0) {
                    return arr;
                }
                arr.push(data[0].id);
                if (data[0].children && data[0].children.length > 0) {
                    let result = this.getRowKeys(data[0].children);
                    arr = arr.concat(result);
                }
                return arr;
            },
            // 获取试题库分类列表
            getQuestionsList() {
                let param = {
                    type: 3,
                    limit:this.coursePages.eachPageNum,
                    page:this.coursePages.currentPageNum
                }
                catePage(param).then((res) => {
                    // this.questionsTable = res.data.list
                    let arr = [];
                    for(let i in res.data.list){
                        arr.push(this.grading(res.data.list[i]))
                    }
                    this.questionsTable = arr;
                    this.coursePages.total = res.data.total;
                }).catch((err) => {
                    console.error('err', err);
                });
            },
            // 添加分类
            addClassify(row){
                if (row) {
                    this.addClassifyForm.id = row.id;
                    this.currentLevel = row.level;
                    if (row.level === 1) {
                        this.classifyTitleType = '添加二级分类'
                    }else {
                        this.classifyTitleType = '添加三级分类'
                    }
                } else {
                    this.currentLevel = 0;
                    this.classifyTitleType = '添加分类'
                }
                this.dialogAddClassify = true;
                this.distinguishBtn = 'add';
                // if (row) {
                //     this.addClassifyForm.id = row.id;
                //     this.classifyTitleType = '添加二级分类'
                //     if (row.pid){
                //         this.classifyTitleType = '添加三级分类'
                //     }
                // } else {
                //     this.classifyTitleType = '添加分类'
                // }
                // this.dialogAddClassify = true;
                // this.distinguishBtn = 'add';
            },
            //编辑
            editClassify(row){
                this.addClassifyForm.name = row.name;
                this.addClassifyForm.id = row.id;
                if(row.level===1){
                    this.classifyTitleType = '编辑分类'
                }else if(row.level===2) {
                    this.classifyTitleType = '编辑二级分类'
                }else{
                    this.classifyTitleType = '编辑三级分类'
                }
                this.dialogAddClassify = true;
                this.distinguishBtn = 'edit';
                // this.addClassifyForm.name = row.name;
                // this.addClassifyForm.id = row.id;
                // this.classifyTitleType = '编辑二级分类'
                // if(row.pid){
                //     this.classifyTitleType = '编辑三级分类'
                // }else {
                //     this.classifyTitleType = '编辑分类'
                // }
                // this.dialogAddClassify = true;
                // this.distinguishBtn = 'edit';
            },
            //确定事件
            addToForm(formName){
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        let param = {
                            type: 3,
                            name: this.addClassifyForm.name
                        }
                        if (this.distinguishBtn === 'edit') {
                            // 编辑
                            param.id = this.addClassifyForm.id
                        }
                        if (this.currentLevel>0) {
                            param.pid = this.addClassifyForm.id
                        }
                        add(param).then((res) => {
                            this.$message.success(res.msg);
                            this.dialogAddClassify = false;
                            this.getQuestionsList();
                            this.resetForm();
                        }).catch((err) => {
                            console.log('err', err)
                        })
                    }
                });
            },
            //删除
            deleteClassifyRow(id){
                this.$confirm(`是否删除该分类，删除将无法恢复`, '删除', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    customClass: 'green-message-box',
                    type: 'warning'
                }).then(() => {
                    del(id).then((res) => {
                        console.log(res)
                        this.$message({
                            message: res.msg,
                            type: 'success',
                            onClose: () => {
                                this.getQuestionsList()
                            }
                        })
                    }).catch((err) => {
                        console.log('err', err)
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                })

            },
            //重置表单
            resetForm() {
                this.$refs.addClassifyForm.resetFields();
                this.addClassifyForm = this.$options.data().addClassifyForm;
            },
            // 切换分页
            courseCurrentChange(val){
                this.coursePages.currentPageNum = val;
            }
        }
    }
</script>

<style scoped lang="scss">
    .course-manage{
        display: flex;
        flex-direction: column;
        height: 100%;
        padding: 0 20px;
        .add-btn-left{
            display: flex;
            justify-content: flex-end;
            padding-bottom: 20px;
        }
        .dialog-footer{
            text-align: center;
            margin-top: 20px;
        }
    }
</style>